<template>
	<div class="no-results width-100 display-flex flex-align-center pl-1">No data found</div>
</template>
<script>
export default { name: 'NoDataFoundMessage' };
</script>
<style lang="scss" scoped>
.no-results {
	height: 25px;
	font-size: 12px;
	color: var(--secondary-font-color);
}
</style>
